/* RVP with QC › How it works (static help) — v5 mockup UI (rvpQc.css). */
import React from 'react'
import PageTitle from '../../../components/PageTitle'
import './rvpQc.css'

const ITEMS = [
  { h: 'Merchant-level & global', p: 'QC is configured per merchant and applies to all that merchant’s reverse pickups, regardless of courier.' },
  { h: 'Three QC types', p: 'Standard runs one fixed checklist; Reason-based picks checks from the verbatim return reason; Non-QC runs no checks at all.' },
  { h: 'Mandatory vs optional', p: 'A mandatory check with missing data fails shipment creation. An optional one is skipped. New parameters default to mandatory.' },
  { h: 'Return reason = verbatim', p: 'Matched on the exact string the customer submitted. Do not paraphrase — wording, spelling and casing must match.' },
  { h: 'Courier QC Master', p: 'The parent-level technical mapping — which ProShip Master Parameters each courier supports and the Courier QC Parameter / API field / question JSON behind them.' },
  { h: 'Set-up path (3 steps)', p: '1 Define the constant ProShip Master Parameters → 2 Map each courier’s PCIS QC parameters to a master → 3 Review the full mapping. Courier QC parameters are added in PCIS; this screen only maps them.' },
  { h: 'Image not received', p: 'Mandatory image check with no photo captured → creation fails; optional → skipped.' },
]

export default function RvpQcHelp() {
  return (
    <div className="rvpqc">
      <PageTitle>RVP with QC · How it works</PageTitle>
      <div className="card">
        <h2>How RVP with QC works at Prozo</h2>
        <div className="ctx">Plain-language reference so the workflow is unambiguous for the backend build.</div>
        <div className="help-grid">
          {ITEMS.map((it) => (
            <div className="hc" key={it.h}><h4>{it.h}</h4><p>{it.p}</p></div>
          ))}
        </div>
      </div>
    </div>
  )
}
